<!--
Author: XiangChenyu
Date: 2019-11-14
Desc: 绑定经办人
 -->
<template>
    <div :class="'view-bind-actor view view-border bg-white ' + className">
        <comp-title :title="title" />
        <div>
            <div class="hk-tit">
                请选择经办人进行绑定
            </div>
            <div>
                <el-table
                    ref="actorTable"
                    :data="tableData"
                    style="width: 100%"
                    class="tab-list-tit hk-tab"
                    highlight-current-row
                    v-on:row-click="clickRow"
                >
                    <el-table-column width="200" align="center">
                        <template slot-scope="scope">
                            <el-radio v-model="radio" class="radio" :label="scope.$index">
                                &nbsp;
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="custname" label="经办人姓名"></el-table-column>
                    <el-table-column prop="certificatetype" label="证件类型" :formatter="certyFormat"></el-table-column>
                    <el-table-column prop="certificateno" label="证件号码" align="left"></el-table-column>
                </el-table>
            </div>
            <div style="margin: 60px;">
                <el-form
                    ref="agentInfo"
                    :model="agentInfo"
                    :rules="rules"
                    label-width="400px"
                    class="acct-form"
                    v-on:submit.native.prevent
                >
                    <el-form-item label="设置登录密码" prop="pwd">
                        <el-input
                            v-model.trim="agentInfo.pwd"
                            :type="pwdType"
                            placeholder="请输入登录密码"
                            :disabled="!checked"
                            :maxlength="16"
                        >
                            <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                        </el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPwd">
                        <el-input
                            v-model.trim="agentInfo.confirmPwd"
                            :type="pwdType"
                            :disabled="!checked"
                            placeholder="请再输入一次登录密码"
                            :maxlength="16"
                        >
                            <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                        </el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="mobileno">
                        <span>{{ agentInfo.mobileno.trim() ? agentInfo.mobileno : "--（若需要购买专户产品请联系柜台人员添加手机号码再进行绑定操作）" }}</span>
                    </el-form-item>
                    <el-form-item class="margin-top">
                        <el-button type="yellow" :disabled="agentInfo.pwd==''||agentInfo.confirmPwd==''" class="medium" v-on:click.prevent="submitForm('agentInfo')">
                            确认
                        </el-button>
                        <el-button class="medium" type="back" v-on:click.prevent="$router.back()">
                            返回
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import format from "date-fns/format";
import mixin from "@/assets/js/mixin";
export default {
    name: "Remitinfo",
    mixins: [mixin],
    data () {
        return {
            tableData: [],
            radio: "",
            agentInfo: {
                pwd: "",
                confirmPwd: "",
                mobileno: ""
            }, //经办人信息
            checked: false, // 是否已经选择经办人
            iconCla: "fa fa-eye-slash", // 密码输入框图标
            pwdType: "password", // 密码输入框类型
            rules: {
                pwd: [
                    { validator: this.$util.validatePwd, trigger: "blur" },
                    { validator: this.pwdCheck, trigger: "blur" }
                ],
                confirmPwd: [
                    { validator: this.$util.validatePwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ]
            }
        };
    },
    created () {
        this.getactorinfo();
    },
    methods: {
        certyFormat (row, column, value) {
            return this.$cache.getDict("130007", value);
        },
        getactorinfo(){
            //获取经办人信息
            this.$util.request("acct/info/transactorInfo","GET").then(res=>{
                if(res.data){
                    this.tableData = res.data;
                }else {
                    this.$message.error(res.msg);
                }
            });
        },
        /* 确认密码校验 */
        pwdCheck (rule, value, callback) {
            if (this.agentInfo.confirmPwd !== "") {
                this.$refs["agentInfo"].validateField("confirmPwd");
            }
            callback();
        },
        /* 确认密码校验 */
        confirm (rule, value, callback) {
            if (this.agentInfo.pwd !== this.agentInfo.confirmPwd && this.agentInfo.pwd !== "") {
                callback(new Error("输入密码和确认密码不一致"));
            } else {
                callback();
            }
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange () {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        clickRow(row){
            this.checked = true;
            this.radio = this.tableData.indexOf(row);
            this.agentInfo = row;
            this.$set(this.agentInfo,"pwd","");
            this.$set(this.agentInfo,"confirmPwd","");

        },
        //提交数据
        submitForm(name){
            const _this = this;
            this.$refs[name].validate((valid) => {
                if (valid) {
                    const data = {
                        certificatetype: this.agentInfo.certificatetype,
                        certificateno: this.agentInfo.certificateno,
                        custname: this.agentInfo.custname,
                        custno: this.agentInfo.custno,
                        loginpwd: this.$util.enc(this.agentInfo.pwd),
                        email: this.agentInfo.email,
                        mobile: this.agentInfo.mobile,
                        vailddate: this.agentInfo.vailddate
                    };
                    this.$util.request("acct/transactor/bind",data,"POST").then(res=>{
                        if(res.data){
                            _this.$confirm("经办人账户已绑定成功，可凭此账号登录!", "绑定结果提示", {
                                confirmButtonText: "下一步",
                                cancelButtonText: "登录",
                                type: "warning",
                                customClass: "info-check"
                            }).then(() => {
                                _this.$router.replace({name: "home"});
                            }).catch(() => {
                                _this.$router.replace({name: "login"});
                            });
                        }else {
                            this.$message.error(res.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="scss">
    .view-bind-actor {
        overflow: hidden;
        .hk-tit{
            color: #cd8200;
            height: 80px;
            text-align: center;
            line-height: 80px;
            font-size: 18px;
        }
        .hk-tab{
            font-size: 16px;
            color: #333333;
            line-height: 40px;
        }
        .el-input{
            width: 50%;
        }
    }
</style>
